import { render, staticRenderFns } from "./shebei.vue?vue&type=template&id=42cf1dea&scoped=true&"
import script from "./shebei.vue?vue&type=script&lang=js&"
export * from "./shebei.vue?vue&type=script&lang=js&"
import style0 from "./shebei.vue?vue&type=style&index=0&id=42cf1dea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cf1dea",
  null
  
)

export default component.exports